//import LOGO from './img/layout/sigla-guvern.png'
import axios from 'axios'

const WEBSITE_NAME = 'C.S.E.I. Lacrima'

let BASE = window.location.protocol + "//" + window.location.hostname
let ORIGIN = BASE
if(BASE==='http://localhost' || BASE.indexOf('http://192.') === 0 || BASE.indexOf('http://89.')===0) {
	ORIGIN = BASE + (window.location.port ? ':' + window.location.port: '')
	BASE = 'https://scoalalacrima.ro'
}

const API = '/api'
const auth0 = '9gAc1ObKvZACAL6l0sjTC5rOZakUqmxW'
const axiosInstance = axios.create({
  	baseURL: BASE,
  	timeout: 150000,
});
const captcha = "6LcO1D4UAAAAAN3Hljc1OsTJcBxLtTNNdwdcQi-n"
const LANGUAGES = null
const palette = {
	white: '#FFFFFF',
    gray: '#6F6F6F',
    blue: '#0ea9fb',
	orange: '#fa9b1b',
	'blue-light': '#257aca',
	'blue-dark': '#1d389f',
	violet: '#bd89e9'
}
const styles = {
    'thumb': [320, 180, false, 100],
    'header': [1200, 800, true, 90],
    'hero': [2040, 1200, true, 100],
    'img': [1200, 1200, true, 90],
    'gallery-th': [320, 320, false, 80],
    'gallery-full': [800, 600, true, 90],
}
const regions = {
	header: {name: 'Antet'},
	main: {
		name: 'Main',
		scrollable: true,
		regions: {
			hero: {name: 'Hero'},
			content: {
				name: 'Conținut',
				regions: {
					left: {name: 'Stânga'}, 
					center: {name: 'Centru'}, 
					right: {name: 'Dreapta'}, 
				}
			},
			footer: {name: 'Subsol'}
		}
	}
}
export {
        //LOGO,
        WEBSITE_NAME,
        ORIGIN,
        BASE,
        API,
        axiosInstance as axios,
        auth0,
        LANGUAGES,
        palette,
        captcha,
        styles,
        regions
}



// WEBPACK FOOTER //
// ./src/config.js